import { addOpacityToThemeColor } from '@/utils/styles/addOpacity';
import { useTheme } from '@mui/material';

export const FileIcon = () => {
    const theme = useTheme();
    const iconColour = addOpacityToThemeColor(theme.colors.palette.text.primary, 0.8);

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H15L17 5V15"
                stroke={iconColour}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15 19L17 21L21 17"
                stroke={iconColour}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7 13H13M7 9H13M15 3V5H17L15 3Z"
                stroke={iconColour}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
